import { gql } from '@web/federation/gql'

export const UpcomingTrainTicketQuery = gql(`
  query UpcomingTrainTicketQuery($limit:Int,$after:String) {
    me {
      ...on MeSucceed {
        ...UpcomingSection_UpcomingTrainTickets
      }
    }
  }

  fragment UpcomingSection_UpcomingTrainTickets on MeSucceed {
    upcomingTrainTickets(input:{pagination:{first:$limit,after:$after}}) {
      edges {
        ... on UpcomingTrainTicketEdge {
          cursor
          node {
            ...UpcomingSection_UpcomingTrainTicket
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        totalCount
      }
    }
  }

  fragment UpcomingSection_UpcomingTrainTicket on UpcomingTrainTicket {
       id
       ticketType
       ticketStatus
       ticketInfoText
       journey {
         journeyAt
         totalPrice
         firstTrain {
           name
           trainNumber
           arrivalAt
           departureAt
           arrivalStop {
             name
           }
           departureStop {
             name
           }
           seats {
             carNumber
             seatNumber
           }
         }
         secondTrain {
           name
           trainNumber
           arrivalAt
           departureAt
           arrivalStop {
             name
           }
           departureStop {
             name
           }
           seats {
             carNumber
             seatNumber
           }
         }
       }
       displayOrderTimestamp
       landingUrl {
          webUrl
          pcWebUrl
       }
  }
`)
